import { api } from './client';

export interface HouseholdItem {
  id: string;
  name: string;
  category: string | null;
  quantityAtHome: string | null;
  defaultQuantityToBuy: string | null;
  notes: string | null;
  lastStoreName: string | null;
  lastUnitPrice: string | null;
  lastBrand: string | null;
  needsToBuy: boolean;
  quantityNeeded: string | null;
}

export interface PriceHistory {
  id: string;
  storeName: string;
  purchaseDate: string;
  quantityBought: string;
  unitPrice: string;
  totalPrice: string | null;
}

export const itemsApi = {
  list: (params?: { category?: string; q?: string; needsToBuy?: boolean }) => {
    const qs = new URLSearchParams();
    if (params?.category) qs.set('category', params.category);
    if (params?.q) qs.set('q', params.q);
    if (params?.needsToBuy) qs.set('needsToBuy', 'true');
    return api.get<HouseholdItem[]>(`/items${qs.size ? '?' + qs : ''}`);
  },
  get: (id: string) => api.get<HouseholdItem>(`/items/${id}`),
  create: (data: Partial<HouseholdItem>) => api.post<HouseholdItem>('/items', data),
  update: (id: string, data: Partial<HouseholdItem>) =>
    api.patch<HouseholdItem>(`/items/${id}`, data),
  delete: (id: string) => api.delete<void>(`/items/${id}`),
  priceHistory: (id: string) => api.get<PriceHistory[]>(`/items/${id}/price-history`),
  lastPurchase: (id: string) => api.get<PriceHistory | null>(`/items/${id}/last-purchase`),
  bulkMarkNeeded: (items: Array<{ id: string; quantityNeeded?: string; needsToBuy: boolean }>) =>
    api.post<{ updated: number }>('/items/bulk-mark-needed', { items }),
};
